import React, { PureComponent } from 'react';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../support';
import LoadingButton from '../../../facturotopia/LoadingButton';

class DashboardClientesDownload extends PureComponent {
  state = {
    busy: false,
  };

  handleOnDownloadActionClick = async (detailed) => {
    this.setState({
      busy: true,
    });

    const params = {
      ...this.props,
      detailed: detailed,
    };

    try {
      const headers = {
        'X-Tenancy': 'fa/live',
      };

      const response = await Http.get(`${window.BONJOUR_URL}/api/admin/dashboard/consumo/download`, {
        params,
        responseType: 'blob',
        headers,
      });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { busy } = this.state;

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={true}
      >
        <LoadingButton
          variant="secondary"
          loading={busy}
          onClick={this.handleOnDownloadActionClick.bind(this, undefined)}
        >
          {busy === true ? 'Descargando' : 'Descargar'}
        </LoadingButton>

        <Dropdown.Toggle
          split
          variant="secondary"
          id="dropdown-split-basic"
        />

        <Dropdown.Menu>
          <Dropdown.Item
            as="div"
            onClick={this.handleOnDownloadActionClick.bind(this, 1)}
          >
            Descargar detallado
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default DashboardClientesDownload;
